"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useThrottle", {
    enumerable: true,
    get: ()=>useThrottle
});
const _interopRequireDefault = require("@swc/helpers/lib/_interop_require_default.js").default;
const _react = require("react");
const _throttle = /*#__PURE__*/ _interopRequireDefault(require("lodash/throttle"));
const _useDeepEqualMemo = require("../useDeepEqualMemo");
function useThrottle(func, dependencies, delay, options) {
    // memoize options so they don't throw off the throttle memo
    const memoizedOptions = (0, _useDeepEqualMemo.useDeepEqualMemo)(options);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const throttledFunction = (0, _react.useMemo)(()=>(0, _throttle.default)(func, delay, memoizedOptions), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        // eslint-disable-next-line react-hooks/exhaustive-deps
        ...dependencies,
        delay,
        memoizedOptions
    ]);
    (0, _react.useEffect)(()=>{
        return ()=>{
            throttledFunction.cancel();
        };
    }, [
        throttledFunction
    ]);
    return throttledFunction;
}
